import type { ReactElement } from 'react';

import { useTheme } from '@emotion/react';

import type { IconComponent } from '@twistopayments/design-system/icons/constants';

import { Typography } from '../../atoms/typography';

import * as styles from './message-box.styles';

export type Colors = 'primary' | 'success' | 'warning' | 'gray';

type Props = {
  icon: IconComponent;
  children: ReactElement | string;
  color: Colors;
  className?: string;
};

export const MessageBox = ({ icon, children, color, className }: Props) => {
  const theme = useTheme();
  const Icon = icon;

  return (
    <div
      className={className}
      css={[styles.box(theme), styles.background[color](theme)]}
      data-testid="message-box">
      <Icon color={color} size="24" />
      <Typography variant="b4">{children}</Typography>
    </div>
  );
};
